import { FC } from 'react'
import { UpArrowCircleIcon } from '@/atoms/Icons/UpArrowCircleIcon'
import { ParagraphMD } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'

export const BackToTopButton: FC = () => {
  const { t } = useTranslate('pif')

  return (
    <div className="mt-14 px-4 sm:px-0 lg:hidden">
      <a href="#" className="mx-auto flex flex-col items-center justify-center">
        <UpArrowCircleIcon />
        <ParagraphMD color="core-gray-500">{t('backToTop', 'Back to top')}</ParagraphMD>
      </a>
    </div>
  )
}
